/**
 * CODE_INDEX represents the short form string for a fixture (i.e. "bre", "LIV", "MCI" etc.)
 */
type CODE_INDEX = string;

/**
 * DESCRIPTION_INDEX represents the full fixture name (i.e. "Brentford (A)", "Liverpool (H)" etc.)
 */
type DESCRIPTION_INDEX = string;

/**
 * FIXTURE_DIFFICULTY_INDEX represents the difficulty level of the fixture (integer number between 1 and 5)
 */
type FIXTURE_DIFFICULTY_INDEX = number;

/**
 * FIXTURE_LIKELIHOOD_INDEX represents the likelihood of the fixture being arranged and means its a predicted fixture (i.e. 0.5, 0.75, a float number between 0 and 1)
 */
type FIXTURE_LIKELIHOOD_INDEX = number;

export type Fixture = [
  CODE_INDEX,
  DESCRIPTION_INDEX,
  FIXTURE_DIFFICULTY_INDEX,
  FIXTURE_LIKELIHOOD_INDEX?
];

export const ratingTypes = {
  OVERALL: 'overall',
  ATTACK: 'attack',
  DEFENCE: 'defence'
};

export const tickerTypes = {
  DIFFICULTY: 'difficulty',
  FORECAST: 'forecast'
};

export const fixtureStyles = {
  1: 'text-neutral-800 bg-[#A9D3CA]',
  2: 'text-neutral-800 bg-[#A9D3CA]',
  3: 'text-neutral-800 bg-[#A9D3CA]',
  4: 'text-neutral-800 bg-[#DAECE8]',
  5: 'text-neutral-800 bg-[#F3E7DA]',
  6: 'text-neutral-800 bg-[#F3E7DA]',
  7: 'text-neutral-800 bg-[#F7D9E3]',
  8: 'text-neutral-800 bg-[#F7D9E3]',
  9: 'text-neutral-800 bg-[#F2BFCF]',
  10: 'text-neutral-800 bg-[#F2BFCF]'
};

export const getPredictedPointsLevelStyles = (points) => {
  switch (true) {
    case points < 2.5: {
      return 'text-neutral-800 bg-[#F2BFCF]';
    }
    case points < 3.5: {
      return 'text-neutral-800 bg-[#F7D9E3]';
    }
    case points < 4.5: {
      return 'text-neutral-800 bg-[#F3E7DA]';
    }
    case points < 6.5: {
      return 'text-neutral-800 bg-[#DAECE8]';
    }

    default:
      return 'text-neutral-800 bg-[#A9D3CA]';
  }
};
